import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useAllowedMobileAppBannerPage } from '../../hooks/useAllowedMobileAppBannerPage';
import { useIsBannerSkipped } from '../../hooks/useIsBannerSkipped';
import { selectMobileBannerCookieState } from '../../selectors/cookies/selectMobileBannerCookieState';
import { selectProfilingCookieState } from '../../selectors/cookies/selectProfilingCookieState';
import { useApplicationContext } from '../../utils/applicationContext';

export function useIsFullscreenBannerSkipped(): boolean {
  const { config } = useApplicationContext();
  const mobileBannerEnabled = config.get<boolean>('mobileBanner.enabled') ?? false;
  const isWebView = config.get<boolean>('web.isWebView') || false;
  const mobileBannerShown = useSelector(selectMobileBannerCookieState);
  const catProfilingCompleted = useSelector(selectProfilingCookieState);
  const shoudlShowCatProfiling = useMemo(
    () => (config.get<boolean>('BX.CatProfiling.Enabled') ?? false) && !catProfilingCompleted,
    [catProfilingCompleted, config],
  );
  const isAllowedPage = useAllowedMobileAppBannerPage();
  const isBannerSkipped = useIsBannerSkipped();

  return useMemo(
    () =>
      !mobileBannerEnabled ||
      shoudlShowCatProfiling ||
      mobileBannerShown ||
      !isAllowedPage ||
      isBannerSkipped ||
      isWebView,
    [isAllowedPage, isBannerSkipped, isWebView, mobileBannerEnabled, mobileBannerShown, shoudlShowCatProfiling],
  );
}
